module.exports = __webpack_public_path__ + "static/media/bar7.a2ca0439.svg";